import { ButtonIconPlainPermissioned } from "pages/gdt/plain/ButtonIconPlain";
import { DATA_TABLE_TOOLTIP_ID } from "../DataTableTooltip";
import { useState } from "react";
import { ModalDeleteRows } from "pages/gdt/modals/ModalDeleteRows";

interface QuickActionDeleteRowBaseProps {
  tableId: string;
  rowIds: string[];
  tooltipContent: string;
  isDisabled: boolean;
  id: string;
}

const QuickActionDeleteRowBase = ({
  tableId,
  rowIds,
  tooltipContent,
  isDisabled,
  id,
}: QuickActionDeleteRowBaseProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <ModalDeleteRows
          tableId={tableId}
          rowIds={rowIds}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <ButtonIconPlainPermissioned
        requiredPermission="edit"
        aria-label={tooltipContent}
        data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
        data-tooltip-content={tooltipContent}
        iconSize="m"
        iconType="minusInCircle"
        color="danger"
        onClick={() => setIsModalOpen(true)}
        disabled={isDisabled}
        id={id}
      />
    </>
  );
};

interface QuickActionDeleteRowProps {
  tableId: string;
  rowId: string;
  readOnly?: boolean;
}

export const QuickActionDeleteRow = ({
  tableId,
  rowId,
  readOnly,
}: QuickActionDeleteRowProps) => {
  return (
    <QuickActionDeleteRowBase
      tooltipContent="Delete row"
      tableId={tableId}
      rowIds={[rowId]}
      isDisabled={readOnly ?? false}
      id={"quickActionDeleteRow"}
    />
  );
};

export interface QuickActionDeleteSelectedRowsProps {
  selectedRowIds: string[];
  tableId: string;
}
export const QuickActionDeleteSelectedRows = ({
  selectedRowIds,
  tableId,
}: QuickActionDeleteSelectedRowsProps) => {
  return (
    <QuickActionDeleteRowBase
      tooltipContent={
        selectedRowIds.length > 1
          ? `Delete ${selectedRowIds.length} selected rows`
          : "Delete selected row"
      }
      tableId={tableId}
      rowIds={selectedRowIds}
      isDisabled={selectedRowIds.length === 0}
      id={"quickActionDeleteSelectedRows"}
    />
  );
};
